export async function getDeviceFingerprint() {
  const rawFingerprint = JSON.stringify({
    userAgent: navigator.userAgent, /** add_2FA_Haidar */
    language: navigator.language, /** add_2FA_Haidar */
    platform: navigator.platform, /** add_2FA_Haidar */
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, /** add_2FA_Haidar */
    screen: `${window.screen.width}x${window.screen.height}x${window.screen.colorDepth}`, /** add_2FA_Haidar */
  });

  if (!window.crypto?.subtle) {
    return rawFingerprint; /** add_2FA_Haidar */
  }

  const encoded = new TextEncoder().encode(rawFingerprint); /** add_2FA_Haidar */
  const digest = await window.crypto.subtle.digest("SHA-256", encoded); /** add_2FA_Haidar */
  const bytes = Array.from(new Uint8Array(digest)); /** add_2FA_Haidar */

  return bytes.map((byte) => byte.toString(16).padStart(2, "0")).join(""); /** add_2FA_Haidar */
}
